/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleMerchantMarketReportRowData
 */
export interface GoogleMerchantMarketReportRowData {
    /**
     * 
     * @type {object}
     * @memberof GoogleMerchantMarketReportRowData
     */
    data?: object;
}

/**
 * Check if a given object implements the GoogleMerchantMarketReportRowData interface.
 */
export function instanceOfGoogleMerchantMarketReportRowData(value: object): value is GoogleMerchantMarketReportRowData {
    return true;
}

export function GoogleMerchantMarketReportRowDataFromJSON(json: any): GoogleMerchantMarketReportRowData {
    return GoogleMerchantMarketReportRowDataFromJSONTyped(json, false);
}

export function GoogleMerchantMarketReportRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleMerchantMarketReportRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function GoogleMerchantMarketReportRowDataToJSON(json: any): GoogleMerchantMarketReportRowData {
    return GoogleMerchantMarketReportRowDataToJSONTyped(json, false);
}

export function GoogleMerchantMarketReportRowDataToJSONTyped(value?: GoogleMerchantMarketReportRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
    };
}

